import { useEffect, useRef } from 'react';
import { MiniStory } from './MiniStory';
import { STORIES } from '../model/data';
import cls from './MiniStoriesList.module.scss';

type Props = {
    watchedStoriesIds: Set<number>;
    onStoryClick: (id: number) => void;
};

export const MiniStoriesList = ({ watchedStoriesIds, onStoryClick }: Props) => {
    const containerRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        const container = containerRef.current;

        if (!container) return;

        const handleWheel = (e: WheelEvent) => {
            if (e.deltaY === 0) return;
            e.preventDefault();
            container.scrollLeft += e.deltaY + e.deltaX;
        };

        container.addEventListener('wheel', handleWheel, { passive: false });

        return () => {
            container.removeEventListener('wheel', handleWheel);
        };
    }, []);

    return (
        <div className={cls.container} ref={containerRef}>
            {STORIES.map((story) => {
                const { id, image, title, alignment = 'start' } = story;

                return (
                    <MiniStory
                        key={id}
                        title={title}
                        image={image}
                        alignment={alignment}
                        isWatched={watchedStoriesIds.has(id)}
                        onClick={() => onStoryClick(id)}
                    />
                );
            })}
        </div>
    );
};
